import React from "react";
import { Link } from "react-router-dom";
import { Gallery } from "../components/Sections";
import PageHero from "../components/PageHero";
import Seo from "../components/seo/Seo";
import JsonLd from "../components/seo/JsonLd";
import { InterestCta, TextLink } from "../components/Bits";
import { Reveal } from "../components/Decorative";
import { ROUTES, breadcrumbs } from "../lib/seo";

export default function GalleryPage() {
  return (
    <>
      <Seo route={ROUTES.gallery} />
      <JsonLd data={breadcrumbs([{ name: ROUTES.gallery.crumb, path: ROUTES.gallery.path }])} />

      <PageHero
        eyebrow="Gallery"
        title={<>The <span className="gold-grad italic">light</span> in the room</>}
        intro="Photographs from past Antara editions — faces mid-bhajan, the harmonium, the diyas, the full house. It reads better once you know what's happening."
      >
        <p className="mt-3 font-body text-base" style={{ color: "#E8D9C5" }}>
          <TextLink to={ROUTES.pillar.path}><span style={{ color: "#E5C880" }}>What is bhajan jamming?</span></TextLink>
        </p>
        <p className="mt-5 font-body text-base" style={{ color: "#E8D9C5" }}>
          Were you at Bhaav Sangam in Chandigarh?{" "}
          <Link to={ROUTES.archiveChandigarh.path} className="underline underline-offset-4" style={{ color: "#E5C880" }} data-testid="gallery-hero-archive-chandigarh">
            Find yourself in 336 more photos →
          </Link>
        </p>
        <p className="mt-2 font-body text-base" style={{ color: "#E8D9C5" }}>
          In Delhi?{" "}
          <Link to={ROUTES.archiveDelhi.path} className="underline underline-offset-4" style={{ color: "#E5C880" }} data-testid="gallery-hero-archive">
            Find yourself in 375 more photos →
          </Link>
        </p>
      </PageHero>

      <Gallery />

      <section className="bg-cream py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <Reveal>
            <InterestCta note="The next set of photographs could have you in them." />
          </Reveal>
        </div>
      </section>
    </>
  );
}
